import { render } from "./CrossIcon.vue?vue&type=template&id=4265ef24"
import script from "./CrossIcon.vue?vue&type=script&lang=js"
export * from "./CrossIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__